var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"outlined":"","small":"","depressed":"","color":"grey darken-2"},on:{"click":function($event){return _vm.handlePayout()}}},[_vm._v("Pay"),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-send")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }